module.exports = __webpack_public_path__ + "img/State=21.6f21bfc5.svg";